var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonHeaderAppleStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0569 19.1432C25.015 14.6013 28.8712 12.3916 29.0475 12.2887C26.8636 9.1842 23.4785 8.76002 22.289 8.7262C19.446 8.43449 16.6882 10.3849 15.24 10.3849C13.7628 10.3849 11.5327 8.75439 9.12902 8.8023C6.03595 8.84881 3.14235 10.5948 1.55534 13.3062C-1.71984 18.8346 0.722818 26.9587 3.86069 31.4274C5.43035 33.6159 7.26451 36.0595 9.66525 35.9736C12.014 35.8791 12.8913 34.5136 15.7256 34.5136C18.534 34.5136 19.3578 35.9736 21.8063 35.9186C24.327 35.8791 25.914 33.7202 27.4287 31.512C29.2426 29.0035 29.9711 26.5332 30 26.4063C29.9407 26.3866 25.1046 24.587 25.0569 19.1432Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4317 5.78656C21.695 4.24628 22.5593 2.15076 22.3194 0.0242424C20.491 0.103159 18.2044 1.25731 16.8877 2.76377C15.7227 4.09126 14.6821 6.26711 14.9509 8.3133C17.0048 8.46268 19.1136 7.30289 20.4317 5.78656Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonHeaderAppleStore);
export default __webpack_public_path__ + "static/media/common_header_apple_store.8a0e04d149a30c7372a30d60b4cf2528.svg";
export { ForwardRef as ReactComponent };